import React, { useState, useCallback } from 'react';
import { Typography, Box, useMediaQuery, useTheme } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { DateField } from '../../../../../Components/Field';
import { TypedFormFieldValue } from '../../../../../Components/Form/Form.types';
import { StepProps } from './types';
import { StepButtonBar } from './StepButtonBar';
import EvaluationStepInfo from './EvaluationStepInfo';

const Step3Dates = ({ onNext, onBack, onCancel, currentData, isFirstStep, evalutionStepInfo, currentStepName, onUpdateEvalution }: StepProps) => {
  const [startDate, setStartDate] = useState<string>(currentData.StartDate || '');
  const [endDate, setEndDate] = useState<string>(currentData.EndDate || '');
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const paperPadding = isMobile ? theme.spacing(3) : theme.spacing(8);

  const handleStartChange = useCallback((val: TypedFormFieldValue<Date> | undefined) => {
    if (val?.value) {
      const d = val.value;
      setStartDate(`${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`);
    } else {
      setStartDate('');
    }
  }, []);

  const handleEndChange = useCallback((val: TypedFormFieldValue<Date> | undefined) => {
    if (val?.value) {
      const d = val.value;
      setEndDate(`${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`);
    } else {
      setEndDate('');
    }
  }, []);

  const handleNext = () => {
    if (startDate && endDate) onNext({ StartDate: startDate, EndDate: endDate });
  };

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            width: isMobile ? '100%' : 'calc(50% - 5px)',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
             minHeight:"350px"
          }}
        >
          {/* <Typography
            variant="h6"
            style={{
              fontWeight: 600,
              marginBottom: theme.spacing(3),
              lineHeight: 1.4,
              textAlign: 'center',
              fontSize: isMobile ? '16px' : '18px',
            }}
          >
            {formatMessage({ id: 'law-portal.evalution.start.date.label' })}
          </Typography> */}
          <Box style={{ maxWidth: '320px', width: '100%', marginBottom: theme.spacing(3) }}>
            <DateField
              name="start-date"
              placeholder={formatMessage({ id: 'law-portal.legal.planned.form.start.date' })}
              errorTexts={[]}
              initialState={currentData.StartDate ? { value: new Date(currentData.StartDate) } : undefined}
              onChange={handleStartChange}
            />
          </Box>

          {/* <Typography
            variant="h6"
            style={{
              fontWeight: 600,
              marginBottom: theme.spacing(3),
              lineHeight: 1.4,
              textAlign: 'center',
              fontSize: isMobile ? '16px' : '18px',
            }}
          >
            {formatMessage({ id: 'law-portal.evalution.end.date.label' })}
          </Typography> */}
          <Box style={{ maxWidth: '320px', width: '100%' }}>
            <DateField
              name="end-date"
              placeholder={formatMessage({ id: 'law-portal.legal.planned.form.end.date' })}
              errorTexts={[]}
              initialState={currentData.EndDate ? { value: new Date(currentData.EndDate) } : undefined}
              onChange={handleEndChange}
            />
          </Box>
        </div>

        <EvaluationStepInfo evalutionStepInfo={evalutionStepInfo} currentStepName={currentStepName} onUpdate={onUpdateEvalution} />
      </div>

      <Box>
        <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={handleNext}
          nextLabel="form.save.and.back"
          nextDisabled={!startDate || !endDate}
          showBack={!isFirstStep}
          formatMessage={formatMessage}
        />
      </Box>
    </div>
  );
};

export default Step3Dates;